/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Permissions_InvalidInputs */

const vi_api_keys_permissions_invalid = /** @type {(inputs: Api_Keys_Permissions_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có quyền không hợp lệ. Tải lại trang rồi chọn lại quyền.`)
};

/**

* @param {Api_Keys_Permissions_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_permissions_invalid = /** @type {((inputs?: Api_Keys_Permissions_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Permissions_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_permissions_invalid(inputs)
});